import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

export class ELDataOptions {
  SubjectId: number;
}

export class ELSummaryForSubject {
  subjectId: number;
  maxDepth: number;
  numberOfSubjects: number;
}

export class ELVisData {
  subjectId: number = 0;
  maxDepth: number = 0;
  numberOfSubjects: number = 0;
  eLNodes: ELNode[] = [];
  eLLinks: ELLink[] = [];
  zoom: number;
  panX: number;
  panY: number;

  width: number;
  height: number;
  fullScreen: boolean;
}

export class ELNode {
  subjectId: number;
  uid: string;
  summary: string;
  subjectType: string;
  color: string;
  canDeleteNode: boolean = false;
}

export class ELLink {
  linkId: number;
  parentSubjectId: number;
  parentSubjectUId: string;
  childSubjectId: number;
  childSubjectUId: string;
  relationshipName: string;
  color: string;
}

@Injectable({
  providedIn: 'root'
})
export class SubjectVisualizerService {
  resourceUrl: string = "api/subjectVisualizer/";
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {
  }

  getSubjectVizData(subjectId: number): Observable<ELVisData> {
    return this.http.get<ELVisData>(this.resourceUrl + "data/" + String(subjectId), this.httpOptions)
      .pipe(
        tap(x => {

          // If not in production mode, color nodes as Red if they can be deleted
          // This is for testing purposes
          if (environment.production === false) {
            // Color nodes as Red if they can be deleted          
            (x as any).nodes.forEach(i => {
              if (i.canDeleteNode)
                i.color = "#ff0000";
            });
          }
        }));
  }

  saveLayout(vizData: any, zoom: number, PanX: number, PanY: number, width: number, height: number, fullScreen: boolean): Observable<boolean> {

    var nodes = [];
    vizData.nodes.forEach(i => {
      nodes.push({ subjectId: i.subjectId, x: i.x || null, y: i.y || null, vx: i.vx || null, vy: i.vy || null, fx: i.fx || null, fy: i.fy || null });
    });
    var data = {
      subjectId: vizData.subjectId,
      zoom: zoom || null,
      panX: PanX || null,
      panY: PanY || null,
      width: width || null,
      height: height || null,
      fullScreen: fullScreen || null,
      nodes: nodes
    };

    return this.http.post(this.resourceUrl + "saveLayout", data, this.httpOptions)
      .pipe(
        map((response: string) => {
          // Check the HTTP status          
          if (response && response == 'OK') {
            return true;
          } else {
            return false;
          }
        })
      );

  }
}